import { render, staticRenderFns } from "./WEBOFFCANVAS.vue?vue&type=template&id=0b2153ba"
import script from "./WEBOFFCANVAS.vue?vue&type=script&lang=js"
export * from "./WEBOFFCANVAS.vue?vue&type=script&lang=js"
import style0 from "./WEBOFFCANVAS.vue?vue&type=style&index=0&id=0b2153ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports